import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
import Icon from 'components/icon';

export default function ResourceGroup({ group }) {
    return (
        <div className="resource-group">
            <h4>{group.label}</h4>
            <ul>
                {group.values.map((resource, index) => (
                    /* eslint-disable react/no-array-index-key */
                    // The resources does not contain unique id value from the data
                    <li key={index} className="resource-item">
                        <a href={resource.url}>
                            {resource.filesize &&
                                <small>({resource.filesize})</small>
                            }
                            <span>{resource.text}</span> {resource.icon && <Icon glyph={resource.icon} />}
                        </a>
                    </li>
                    /* eslint-enable react/no-array-index-key */
                ))}
            </ul>
        </div>
    );
}

ResourceGroup.propTypes = {
    group: shape({
        label: string.isRequired,
        values: arrayOf(shape({
            url: string.isRequired,
            text: string.isRequired,
            filesize: string,
            icon: string
        })).isRequired
    }).isRequired
};
